module.exports = __webpack_public_path__ + "img/dsci0016.696e2574.jpg";